var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#92982f",
    d: "M2 0h1m0 1h1m2 0h1M3 2h1m2 0h1M1 3h1m3 0h1m4 0h1M0 4h5m2 0h1m1 0h1M2 5h1m2 0h5M3 6h1M3 7h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#aaa525",
    d: "M3 0h4M1 1h2m1 0h2m1 0h2M1 2h2m1 0h2m1 0h4M0 3h1m1 0h3m1 0h4M5 4h1m2 0h1M5 6h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#767925",
    d: "M11 3h1M6 4h1m3 0h2M1 5h1m2 0h1m5 0h2M2 6h1m1 0h1m1 0h2m1 0h2M5 7h1m1 0h1m1 0h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7c4d2e",
    d: "M3 5h1m4 1h1M8 7h1M7 8h1M5 9h2m-1 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#89682f",
    d: "M4 7h1m1 0h1M4 8h3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6a3829",
    d: "M5 10h1m-1 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree3);
export default __webpack_public_path__ + "static/media/tree3.067c70b88d89e669343b3bafde5bb07c.svg";
export { ForwardRef as ReactComponent };